/**
 * Retorna fecha local en formato YYYY-MM-DD (sin depender de locale del navegador).
 */
export const getLocalDateYMD = (date: Date = new Date()): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Retorna la fecha y hora actuales en zona horaria de Chile (America/Santiago),
 * independientemente de la zona local del navegador.
 *
 * Necesario porque la app sirve rutas chilenas: un usuario en España a las 20:00
 * ve Chile a las 14:00-16:00, y el slider de horarios debe bloquearse según la
 * hora chilena, no la española.
 */
export const getChileNow = (): { date: string; hours: number; minutes: number } => {
  const now = new Date();
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Santiago',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(now);

  const get = (type: string) => parts.find(p => p.type === type)?.value ?? '0';
  return {
    date:    `${get('year')}-${get('month')}-${get('day')}`,
    hours:   parseInt(get('hour')),
    minutes: parseInt(get('minute')),
  };
};
